/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
    selector: '[appAutoFocus]'
})
export class AutoFocusDirective implements OnInit {
    @Input() set autofocus(condition: boolean) {
        this._autofocus = condition !== false;
    }

    /**
     * Autofocus private variable.
     * @private
     */
    private _autofocus: boolean;

    constructor(
        private elementRef: ElementRef
    ) {
    }

    get autofocus() {
        return this._autofocus;
    }

    ngOnInit() {
        if (this.autofocus || typeof this.autofocus === 'undefined') {
            this.elementRef.nativeElement.focus();
        }
    }
}
